import { getFiscalYear } from 'Common/GeneralHelper';

import * as types from './types';
import { initialGridData } from '../../helpers/constants';

const INITIAL_STATE = {
  loading: false,
  siteId: null,
  fiscalYear: getFiscalYear(new Date()),
  fiscalYears: [],
  siteData: null,
  saveSuccessful: false,
  gridDataLunch: initialGridData,
  gridDataBreakfast: initialGridData,
  otherFiscalYear: null,
  showUseAnotherFiscalYear: false,
  otherFiscalYears: [],
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.BASE_RATES_LOADING:
      return { ...state, loading: payload };

    case types.BASE_RATES_UPDATE_LUNCH_GRID_DATA:
      return { ...state, gridDataLunch: payload };

    case types.BASE_RATES_UPDATE_BREAKFAST_GRID_DATA:
      return { ...state, gridDataBreakfast: payload };

    case types.BASE_RATES_UPDATE_SITE:
      return {
        ...state,
        siteData: payload.response,
        siteId: payload.siteId,
        fiscalYears: payload.response.Years.map(x =>
          parseInt(x.FiscalYear, 10)
        ).sort((a, b) => {
          return b - a;
        }),
      };

    case types.BASE_RATES_SET_SUCCESSFUL:
      return { ...state, saveSuccessful: payload };

    case types.BASE_RATES_UPDATE_FISCAL_YEAR:
      return { ...state, fiscalYear: payload };

    case types.BASE_RATES_UPDATE_OTHER_FISCAL_YEAR:
      return { ...state, otherFiscalYear: payload };

    case types.BASE_RATES_UPDATE_SET_TOGGLE:
      return { ...state, showUseAnotherFiscalYear: payload };

    case types.BASE_RATES_UPDATE_OTHER_FISCAL_YEARS:
      return { ...state, otherFiscalYears: payload };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/pages/provision2baseratessetup/state/provision2BaseRatesSetup/reducer.js